import React from 'react'
import SkeletonElement from './SkeletonElement'

function CardSkeleton() {
  return (
      <div className='skeleton-wrapper__card'>
            <SkeletonElement type='img'/>
            <SkeletonElement type='titleS'/>
            <SkeletonElement type='text'/>
            <div>
                <SkeletonElement type='btn'/>
                <SkeletonElement type='btn'/>
            </div>
            
      </div>
  )
}

export default CardSkeleton
